import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Swiftdzireonrentindaund() {



  const cardData =
  {
    keyword: 'Swift Dzire On Rent in Daund',
    heading: 'Sanavi Travels: Swift Dzire On Rent in Daund',
    headingDescription: 'Sanavi Travels offers reliable Swift Dzire On Rent in Daund, providing safe, comfortable, and affordable transportation for families, solo travelers, corporate clients, and pilgrims. Our fleet of well-maintained Swift Dzire cars ensures smooth rides, air-conditioning, and ample luggage space for a hassle-free journey. With professional chauffeurs, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Daund and nearby areas, making it ideal for local travel, outstation trips, Shirdi visits, airport transfers, and family outings. Choose Sanavi Travels for trusted Swift Dzire rental services in Daund, delivering comfort, safety, and a seamless travel experience.',

    top: 'Top Places to Visit in Daund with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bhigwan Bird Sanctuary",
    "description": "Located near Daund, Bhigwan Bird Sanctuary is a paradise for bird lovers and nature enthusiasts. Often called the 'Bharatpur of Maharashtra,' it attracts migratory birds like flamingos, pelicans, and storks, especially during winter. Boat safaris and sunrise views make it a must-visit destination."
  },
  {
    "title": "Ujani Dam Backwaters",
    "description": "The backwaters of Ujani Dam near Daund offer a serene landscape of vast water spread and open skies. The area is ideal for peaceful outings, photography, and birdwatching, particularly during early mornings and evenings."
  },
  {
    "title": "Shri Siddheshwar Temple",
    "description": "Shri Siddheshwar Temple is an important local religious site in Daund, attracting devotees throughout the year. The temple is known for its calm spiritual atmosphere and traditional rituals performed during festivals."
  },
  {
    "title": "Daund Railway Junction",
    "description": "Daund Railway Junction is one of the major railway hubs in Maharashtra, connecting important routes toward Pune, Solapur, and southern India. The historic junction plays a vital role in trade, travel, and regional connectivity."
  },
  {
    "title": "Bhigwan Wetlands",
    "description": "The wetlands around Bhigwan near Daund support rich biodiversity and seasonal migratory birds. Nature walks and boat rides allow visitors to experience untouched natural beauty and rural landscapes."
  },
  {
    "title": "Local Sugar Factories Area",
    "description": "Daund is surrounded by sugarcane fields and sugar factories that represent the agricultural backbone of the region. These areas highlight rural life and Maharashtra’s cooperative farming culture."
  },
  {
    "title": "Village Temples and Wadas",
    "description": "Traditional village temples and old wadas around Daund reflect the cultural and architectural heritage of rural Maharashtra. These sites offer insight into local traditions, festivals, and community life."
  },
  {
    "title": "Indapur Road Countryside",
    "description": "The countryside along Indapur Road near Daund offers scenic drives with open fields, canals, and sunset views. It is ideal for short nature breaks and relaxed travel experiences."
  },
  {
    "title": "Local Weekly Markets",
    "description": "Weekly markets in Daund are vibrant centers of local trade, selling fresh produce, grains, livestock, and daily essentials. They provide an authentic experience of rural Maharashtra’s lifestyle."
  },
  {
    "title": "Pilgrimage Routes Nearby",
    "description": "Daund lies on important travel routes connecting Pune, Solapur, Pandharpur, and Bhigwan. Many pilgrims use Daund as a transit point while visiting major religious destinations."
  }
]
,



"services": [
  {
    "name": "Swift Dzire On Rent in Daund",
    "description": "Swift Dzire On Rent in Daund provides convenient and comfortable car rental solutions for city travel, outstation trips, and special occasions. Well-maintained vehicles with spacious interiors and air-conditioning ensure a smooth and pleasant ride for families, tourists, and business travelers."
  },
  {
    "name": "Dzire Cab Hire Daund",
    "description": "Dzire Cab Hire Daund offers flexible rental options with professional drivers for short trips, long-distance travel, and airport transfers. Punctual pickups, reliable service, and clean, air-conditioned vehicles guarantee a hassle-free journey every time."
  },
  {
    "name": "AC Dzire Daund",
    "description": "AC Dzire Daund ensures a cool and comfortable ride for daily commutes, intercity travel, and corporate trips. Air-conditioned interiors, comfortable seating, and smooth driving make each trip relaxing and stress-free."
  },
  {
    "name": "Affordable Dzire Cab Daund",
    "description": "Affordable Dzire Cab Daund provides budget-friendly transportation options without compromising on comfort or safety. Ideal for students, families, and small groups, this service delivers reliable, economical travel solutions for city and outstation trips."
  },
  {
    "name": "Chauffeur Driven Dzire Cab",
    "description": "Chauffeur Driven Dzire Cab offers a stress-free travel experience with professional drivers handling navigation, traffic, and route planning. Perfect for family trips, corporate travel, and sightseeing tours, ensuring safe, timely, and comfortable journeys."
  },
  {
    "name": "Best Dzire Service Daund",
    "description": "Best Dzire Service Daund provides premium car rental options with well-maintained vehicles and trained drivers. Ideal for corporate travel, family outings, and outstation trips, this service emphasizes reliability, comfort, and customer satisfaction."
  },
  {
    "name": "Local Dzire Cab Daund",
    "description": "Local Dzire Cab Daund is perfect for intra-city travel, daily commuting, and short trips within Daund. Comfortable, air-conditioned vehicles with professional drivers ensure timely pickups and smooth rides for all local travel needs."
  },
  {
    "name": "Outstation Dzire Cab Daund",
    "description": "Outstation Dzire Cab Daund provides dependable transportation for long-distance trips from Daund to nearby cities and tourist destinations. Spacious, air-conditioned vehicles with experienced chauffeurs ensure safe and comfortable journeys for families, groups, and corporate travelers."
  },
  {
    "name": "Railway Pickup Dzire Daund",
    "description": "Railway Pickup Dzire Daund offers convenient and timely transfers for passengers arriving at Daund railway station. Experienced drivers track train schedules to ensure on-time pickups, providing a smooth, safe, and comfortable ride to your destination."
  },
  {
    "name": "Tourist Dzire Daund",
    "description": "Tourist Dzire Daund is designed for sightseeing and leisure trips around Daund and nearby attractions. Air-conditioned vehicles with professional chauffeurs provide organized, safe, and enjoyable travel experiences for families, groups, and tourists."
  },
  {
    "name": "Corporate Dzire Daund",
    "description": "Corporate Dzire Daund delivers reliable and professional transportation for business executives, employees, and corporate guests. Punctual, air-conditioned vehicles with trained drivers ensure smooth travel for meetings, client visits, conferences, and airport transfers."
  },
  {
    "name": "Online Cab Booking Daund",
    "description": "Online Cab Booking Daund allows passengers to reserve Swift Dzire cabs conveniently through a digital platform. Choose vehicle type, pickup location, dates, and preferences with instant confirmation, ensuring hassle-free, safe, and reliable city, outstation, and corporate travel."
  },
  {
    "name": "Family Dzire Cab",
    "description": "Family Dzire Cab provides safe, comfortable, and spacious transportation for family trips, outings, and special occasions. Air-conditioned interiors, ample seating, and professional chauffeurs ensure enjoyable and stress-free journeys."
  },
  {
    "name": "Airport Transfer Dzire",
    "description": "Airport Transfer Dzire offers timely and comfortable pick-up and drop services for passengers traveling to and from airports. Experienced drivers and air-conditioned vehicles ensure a smooth, punctual, and convenient airport travel experience."
  },
  {
    "name": "Daund Travel Dzire",
    "description": "Daund Travel Dzire delivers complete travel solutions for city tours, outstation trips, and leisure travel. Reliable, air-conditioned vehicles with professional chauffeurs ensure safe, comfortable, and enjoyable journeys for families, tourists, and corporate clients."
  }
],
"tableData": [
  ["Swift Dzire On Rent in Daund", "Dzire Cab Hire Daund"],
  ["AC Dzire Daund", "Affordable Dzire Cab Daund"],
  ["Chauffeur Driven Dzire Cab", "Best Dzire Service Daund"],
  ["Local Dzire Cab Daund", "Outstation Dzire Cab Daund"],
  ["Railway Pickup Dzire Daund", "Tourist Dzire Daund"],
  ["Corporate Dzire Daund", "Online Cab Booking Daund"],
  ["Family Dzire Cab", "Airport Transfer Dzire"],
  ["Daund Travel Dzire", "—"]
]
,

"whychoose": [
  {
    "WhyChooseheading": "Swift Dzire On Rent in Daund with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers comfortable and affordable Swift Dzire rentals in Daund, perfect for local travel, airport transfers, outstation trips, and family journeys."
  },
  {
    "WhyChooseheading": "Well‑Maintained Swift Dzire Vehicles",
    "WhyChoosedescription": "Travel in clean, air‑conditioned, and regularly serviced Swift Dzire cars that ensure a smooth and enjoyable ride."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, punctual, and familiar with local Daund and nearby routes, providing safe and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Swift Dzire rentals in Daund, including fuel, tolls, and driver allowances with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your Swift Dzire rental."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from local, one‑way, round‑trip, or customized rental packages based on your travel requirements in Daund."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Swift Dzire cars are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Swift Dzire rentals in Daund."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Swift Dzire on rent in Daund?',
    answer: 'Yes, Sanavi Travels offers Swift Dzire rentals in Daund for comfortable and affordable travel.'
  },
  {
    question: 'How can I book a Swift Dzire in Daund?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'Is the Swift Dzire well‑maintained and air‑conditioned?',
    answer: 'Yes, all Swift Dzire vehicles provided by Sanavi Travels are clean, air‑conditioned, and regularly serviced.'
  },
  {
    question: 'Are drivers experienced with Daund routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with local and nearby routes for safe travel.'
  },
  {
    question: 'Can I rent Swift Dzire for local or outstation travel?',
    answer: 'Absolutely. You can choose local, one‑way, round‑trip, or customized travel packages based on your needs.'
  },
  {
    question: 'Is the Swift Dzire rental service available 24x7?',
    answer: 'Yes, Sanavi Travels provides round‑the‑clock support for Swift Dzire rentals in Daund.'
  },
  {
    question: 'Are the cars sanitized before every trip?',
    answer: 'Yes, all Swift Dzire cars are thoroughly cleaned and sanitized before departure.'
  },
  {
    question: 'What payment options are available for Swift Dzire bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the ride?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Swift Dzire rental journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Kulkarni',
    feedback: 'Rented a Swift Dzire in Daund for a family trip. Comfortable ride with a professional driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Aarti Deshmukh',
    feedback: 'Excellent Swift Dzire rental service in Daund. Smooth ride, clean car, and responsive support.',
    rating: 5
  }
];
















































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire On Rent in Daund - Sanavi Travels",
  "description": "Sanavi Travels offers Swift Dzire cab hire in Daund for local trips, outstation journeys, family travel, corporate travel, airport transfers, tourist travel, and railway pickups. AC, chauffeur-driven, and affordable services with online booking available.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "760"
  }
};




  return (
    <div>


<Helmet>
  <title>
    Swift Dzire On Rent in Daund | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Swift Dzire cab in Daund with Sanavi Travels for local, outstation, family, corporate, airport, and tourist travel. AC, chauffeur-driven, and affordable Dzire cabs with railway pickup and online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/97.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Swiftdzireonrentindaund;